import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  MenuItem,
  DropdownButton,
} from 'react-bootstrap';

import { bidStates } from '../../../core/api';
import { GROUP_COLORS, EVENT_COLORS } from './EventStyles';


function formatButton(buttons, filterType, filter, setFilter) {
  const isSet = (filter[filterType] === true);
  const indicator = isSet ? (<i className="fa fa-square-o" aria-hidden="true" />) : (<i className="fa fa-check-square-o" aria-hidden="true" />);
  //const style = { color: EVENT_COLORS[filterType] };
  // const colorSwatch = (<i className="fa fa-square fa-stack-2x" aria-hidden="true" style={style} />);
  const filterDisplay = bidStates[filterType];
  buttons.push(
    (<MenuItem
      key={filterType}
      onClick={setFilter}
      data-item={filterType}
      data-value={isSet}
    >
      {indicator} {filterDisplay}
    </MenuItem>),
  );
}
function formatButtonGroup(buttons, group, groupName, filter, setFilter) {
  console.log(group, groupName);
  const isSet = (filter[groupName] === true);
  const indicator = isSet ? (<i className="fa fa-square-o" aria-hidden="true" />) : (<i className="fa fa-check-square-o" aria-hidden="true" />);
  const style = { color: GROUP_COLORS[group % 4] };
  const colorSwatch = (<i className="fa fa-square fa-2x" aria-hidden="true" style={style} />);

  buttons.push(
    (<MenuItem
      key={groupName}
      onClick={setFilter}
      data-item={groupName}
      data-value={isSet}
    >{indicator} {groupName} {colorSwatch}</MenuItem>),
  );
}


const FILTER_TYPES = ['DR', 'ST', 'PD', 'SO', 'DE', 'IN', 'AC', 'CD', 'PB'];

class ManageBidFilterToolbar extends Component {
  constructor(props) {
    super(props);
    this.setFilter = this.setFilter.bind(this);
  }
  setFilter = (e) => {
    const filterType = e.currentTarget.getAttribute('data-item');
    const filterValue = e.currentTarget.getAttribute('data-value') === 'true';
    const newFilter = {};
    // TOGGLE the filter values
    newFilter[filterType] = !filterValue;
    this.props.bidFilterSet(newFilter);
    $("#bg-nested-dropdown").click(function(e){
      e.stopPropagation();
    })

  }

  render() {

    try {
      const buttons = [];
      const groupButtons = [];
      const title = <span><i className="fa fa-filter" aria-hidden="true" /> Filter</span>;
      FILTER_TYPES.forEach((filterType) => {
        formatButton(buttons, filterType, this.props.filter, this.setFilter);
      });
      this.props.groups.forEach((group) => {
        formatButtonGroup(groupButtons, group.id, group.name, this.props.filter, this.setFilter);
      });
      return (
        <span>&nbsp;&nbsp;&nbsp;
          <DropdownButton title={title} id="bg-nested-dropdown" bsStyle="info">
            {buttons}
            <MenuItem divider />
            {groupButtons}
          </DropdownButton>
        </span>
      );
    } catch (e) {
      console.log("Bid Filter -> ", e);
      return null;
    }
  }
}
ManageBidFilterToolbar.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.object.isRequired,
  bidFilterSet: PropTypes.func.isRequired,
};
ManageBidFilterToolbar.defaultProps = {
  filter: {},
};

export default ManageBidFilterToolbar;



// WEBPACK FOOTER //
// src/routes/tours/components/ManageBidFilterDropDown.js